import React from "react"
import Button from "./Button"

const ImageTerms = ({ onAccept }) => {
  return (
    <div>
      <h3>Uploading photos and images</h3>
      <p>
        Please note that in order to use A DESIGN (which can implicate a photo,
        image, text, name, brand or saying) you must have FULL RIGHTS to use
        this design
      </p>
      <p>
        TinyMerch reserves the right to abstain from printing any designs under
        suspicion of being an infringement upon intellectual property rights.
      </p>
      <ul>
        <p>By uploading or saving a design you agree that:</p>
        <li>You hold the rights to commercially reproduce this design.</li>
        <li>
          You also release us from any claims made as a result of any property
          right infringement.
        </li>
        <li>
          You understand that infringement of property rights is illegal. If you
          have any doubt as to the legal ownership of a design you should check
          with the rightful owner that you are able to use the design before
          uploading.
        </li>
        <li>
          You understand that we act under your instructions and are not
          obligated in any way to check or confirm the legal use of reproducing
          any designs.
        </li>
        <li>
          You agree to indemnify and defend Printful for any claims made as a
          result of alleged infringements including copyrights, trademarks,
          rights of publicity, or other intellectual property claims, including
          any payments for damages sustained by a claimant and attorneys’ fees
          incurred by you to defend against any claims made
        </li>
      </ul>
      <form
        onSubmit={e => {
          e.preventDefault()
          onAccept()
        }}>
        <label>
          <input type="checkbox" required /> I understand and accept these
          conditions of intellectual property rights.
        </label>
        <Button styleName="submit" type="submit">
          I accept
        </Button>
      </form>
    </div>
  )
}

export default ImageTerms



// WEBPACK FOOTER //
// ./src/lib/ImageTerms.js